// extracted by mini-css-extract-plugin
module.exports = {"notificationContainer":"styles_notificationContainer__1t1Z0"};